export default __webpack_public_path__ + "static/media/mediumLogo.fc895258.png";